export default "__VITE_ASSET__BiO7uYAH__"